import React from 'react';
import LoginForm from '../features/Auth/components/Login/LoginForm';

function AuthPage() {
    return <LoginForm />;
}

export default AuthPage;